import TipoPresupuestoService from 'src/modules/tipoPresupuesto/tipoPresupuestoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TIPOPRESUPUESTO_VIEW';

const tipoPresupuestoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoPresupuestoViewActions.FIND_STARTED,
      });

      const record = await TipoPresupuestoService.find(id);

      dispatch({
        type: tipoPresupuestoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoPresupuestoViewActions.FIND_ERROR,
      });

      getHistory().push('/tipo-presupuesto');
    }
  },
};

export default tipoPresupuestoViewActions;
